import fgInput from './components/Inputs/formGroupInput.vue'
import DropDown from './components/Dropdown.vue'
import Card from './components/Cards/Card.vue'
import Button from './components/Button.vue';
import {ElInput, ElInputNumber} from 'element-plus'

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (app) {
    app.component('fg-input', fgInput)
    app.component('drop-down', DropDown)
    app.component('card', Card)
    app.component(Button.name, Button)
    app.component(ElInput.name, ElInput)
    app.component(ElInputNumber.name, ElInputNumber)
  }
}

export default GlobalComponents
